import React from "react";
import useStyles from "./profileStyle";
import { useTranslation } from "react-i18next";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import globalStyles from "../../style/global.js";
import EditProfile from "../editProfile/EditProfile";
import ProfileInformation from "../profileInformation/ProfileInformation";
import ChangePassword from "../changePassword/ChangePassword";

import AccountBoxIcon from '@mui/icons-material/AccountBox';
import EditIcon from '@mui/icons-material/Edit';
import PasswordIcon from '@mui/icons-material/Password';
import PageTitle from "../../components/pageTitle/PageTitle";
function Profile() {
  const classes = useStyles();
  const { t } = useTranslation();
  const globalClasses = globalStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={globalClasses.background}>
           <PageTitle title={t("profile")} />
        <Box sx={{ width: "100%" }}>
          <Box className={classes.box}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
               icon={<AccountBoxIcon />} 
                className={classes.tab}
                label={t("information")}
                {...a11yProps(0)}
              />
              <Tab
              icon={<EditIcon />} 
                className={classes.tab}
                label={t("editProfile")}
                {...a11yProps(1)}
              />
              <Tab
              icon={<PasswordIcon />} 
                className={classes.tab}
                label={t("password")}
                {...a11yProps(2)}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            {<ProfileInformation />}
          </TabPanel>
          <TabPanel value={value} index={1}>
            {<EditProfile />}
          </TabPanel>
          <TabPanel value={value} index={2}>
            {<ChangePassword />}
          </TabPanel>
        </Box>
 
    </div>
  );
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default Profile;
